import React from 'react';
import cn from 'classnames';

import styles from './hotelFeature.module.css';

type HotelFeatureProps = {
  Icon: React.ReactNode;
  Label: React.ReactNode;
  isMobile: boolean;
};

const HotelFeature: React.FC<HotelFeatureProps> = ({
  Icon,
  Label,
  isMobile,
}) => (
  <div className={cn(styles.feature, { [styles.featureMobile]: isMobile })}>
    <div className={styles.iconWrapper}>{Icon}</div>
    <div className={styles.label}>{Label}</div>
  </div>
);

export default HotelFeature;
